import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 512 512" {...props}>
      <title id="Star-Empty">{props.title || 'Star-Empty'}</title>
      <g>
        <path d="M349.7 311.7l94.2-91.4-129.9-19.1-58.2-117.5-58.2 117.5-129.8 19.1 94.2 91.4-22.5 129.6 116.3-61.3 116 61.2-22.1-129.5zm162.2-109.9c0 4.5-2.7 9.4-8 14.8l-111.7 108.9 26.5 153.9c.2 1.4.3 3.5.3 6.2 0 10.3-4.2 15.4-12.6 15.4-3.9 0-8-1.2-12.3-3.7l-138.2-72.6-138.2 72.6c-4.5 2.5-8.6 3.7-12.3 3.7-4.3 0-7.5-1.5-9.7-4.5-2.2-3-3.2-6.6-3.2-10.9 0-1.2.2-3.3.6-6.2l26.5-153.9-112.1-108.9c-5.1-5.5-7.7-10.5-7.7-14.8 0-7.6 5.7-12.3 17.2-14.1l154.5-22.5 69.2-140c3.9-8.4 8.9-12.6 15.1-12.6s11.2 4.2 15.1 12.6l69.2 140 154.5 22.5c11.5 1.8 17.3 6.5 17.3 14.1z" />
      </g>
    </Icon>
  )
}



// WEBPACK FOOTER //
// ./client/components/icons/starEmpty.js